function CheckAdminUserId(eid) {
    let userId = [
        {id: 1}, {id: 6}, {id: 13}, {id: 27},
    ]
    let check = false;
    userId.map((c) => {
        if (c.id == eid) {
            check = true;
        }
    })
    return check;
}

export default CheckAdminUserId;
  